function Community() {
    return (
      <div className="community main-page">
        <p>
					Most of the magic happens in discord.
					<li>Discord - <a href='https://discord.gg/nCDMn22DkM'>Snowblossom Discord</a></li>
					<li>Slack - <a href='https://join.slack.com/t/snowblossom/shared_invite/enQtMzY1OTEzODYzNjk5LWI1NThhMTgzNjA3NjkzMmJkOGMwMzFmYzI5M2I4N2I3MWE3ZmVhNDk1NjM5ZmI0NTUyZWI5MjVmY2NlNGRiNGM'>snowblossom.slack.com</a> <a href='https://archive.snowblossom.org/slack/index.html'>archive</a></li>
					<li>Reddit - <a href='https://reddit.com/r/snowblossom'>/r/snowblossom</a></li>
					<li>IRC Freenode #snowblossom</li>
					<li>Youtube - <a href='https://www.youtube.com/channel/UC2ArAOKHi6my2mmOAeIAn6g'>Video channel</a></li>
					<li>Videos also at: <a href='http://snowblossom-video.snowblossom.io/'>snowblossom-video</a> <a href='https://chan-relay.snowblossom.org/channel/snowblossom-video/'>snowblossom-video</a></li>
				</p>
        <a>
        https://snowblossom.org/snowfields/index.html
        </a>
        <a>
        https://snowblossom.org/releases/index.html
        </a>
      </div>
    );
  }
  export default Community;


